import styled from 'styled-components';

import { Button } from '@calm-web/design-system';

// `$marginTop` overrides the default top gap (used by the CS form to align the submit's gap with the
// tighter express/PayPal group rhythm); unset → the standard 1rem the legacy form relies on.
export const SubmitButton = styled(Button)<{ $marginTop?: string }>`
	margin-top: ${({ $marginTop }) => $marginTop ?? '1rem'};
`;
